import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import unAuthedUser from "../fragments/unAuthedUserV4"

const query = gql`
  query UnauthedUser($id: ID!) {
    unAuthedUser(id: $id) {
      ...unAuthedUser
    }
  }
  ${unAuthedUser}
`

export const unAuthedUserKey = getQueryNames(query)[0]

export default query
